module.exports = __webpack_public_path__ + "static/media/hollow_bar_packShip.9e4c93ac.svg";